import styled from 'styled-components';
import { GeneralText } from './GeneralText';

export const CardText = styled(GeneralText)`
  &:first-of-type:first-letter {
    font-family: var(--heading-font), sans-serif;
    font-weight: 600;
    font-size: 3em;
    float: left;
    line-height: 1em;
    margin-right: 0.1em;
    color: hsl(209deg 75% 14%);
  }

  @media (max-width: 500px) {
    text-align: start;
  }
`;